var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.codes,"label":_vm.label,"outline":"","required":_vm.required,"value":_vm.value,"v-model":_vm.code,"rules":[_vm.rules.required, _vm.rules.whitespace],"hint":_vm.hint},on:{"change":_vm.changeValue}})}
var staticRenderFns = []

export { render, staticRenderFns }